import actions from 'circe/listing/actions';
import actionTypes from './actionTypes';

export const {
  fetch, fetchNext, fetchPrev, fetched, fetching, cache,
} = actions(actionTypes);
